import { SxProps, Theme } from '@mui/material';

export type CampaignStatus = 'draft' | 'active' | 'paused' | 'error' | 'moderation' | 'pending_payment';

export const getCampaignStatusText = (status: CampaignStatus | string): string => {
  switch (status) {
    case 'active': return 'Активна';
    case 'paused': return 'Приостановлена';
    case 'draft': return 'Черновик';
    case 'moderation': return 'На модерации';
    case 'pending_payment': return 'Ожидает оплаты';
    case 'error': return 'Ошибка';
    default: return status;
  }
};

export const getCampaignStatusColor = (status: CampaignStatus | string): 'success' | 'warning' | 'info' | 'error' | 'default' => {
  switch (status) {
    case 'active': return 'success';
    case 'paused': return 'warning';
    case 'pending_payment': return 'warning';
    case 'moderation': return 'info';
    case 'error': return 'error';
    default: return 'default';
  }
};

export const getCampaignStatusStyles = (status: CampaignStatus | string): SxProps<Theme> => {
  switch (status) {
    case 'active':
      return {
        bgcolor: '#e8f5e8',
        color: '#155724',
        border: 'none'
      };
    case 'draft':
      return {
        bgcolor: '#fff3cd',
        color: '#856404',
        border: 'none'
      };
    case 'moderation':
      return {
        bgcolor: '#cce5ff',
        color: '#004085',
        border: 'none'
      };
    case 'pending_payment':
      return {
        bgcolor: '#ffe5cc',
        color: '#cc5200',
        border: 'none'
      };
    case 'paused':
      return {
        bgcolor: '#f8d7da',
        color: '#721c24',
        border: 'none'
      };
    case 'error':
      return {
        bgcolor: '#f8d7da',
        color: '#721c24',
        border: 'none'
      };
    default:
      return {
        bgcolor: '#f8d7da',
        color: '#721c24',
        border: 'none'
      };
  }
};

